import React from 'react';
import { connect } from 'react-redux';
import { selectPropertyWalkThroughFormStep } from '../../store/selectors/propertyWalkThroughForm';
import ConfigurePropertyWalkThrough from './ConfigurePropertyWalkThrough';
import ConfigureSubArea from './ConfigureSubArea';
import EasyOccupantWalkThroughForm from './EasyOccupantWalkThroughForm';
import DeveloperWalkthroughContainer from '../../pages/DeveloperWalkthrough/DeveloperWalkthroughContainer';
import ReviewWalkThrough from './ReviewWalkThrough';
import ReviewDeveloperWalkthrough from './ReviewDeveloperWalkthrough';
import { MobileAppCallToAction } from '../MobileAppCallToAction/MobileAppCallToAction';

const PropertyWalkThroughFormSteps = ({
  propertyWalkThroughFormStep,
  ...props
}) => {
  switch (propertyWalkThroughFormStep) {
    case 0:
      return <ConfigurePropertyWalkThrough {...props} />;
    case 1:
      return <ConfigureSubArea {...props} />;
    case 3:
      return <ReviewWalkThrough {...props} />;
    case 5:
      return <ReviewDeveloperWalkthrough {...props} />;
    default:
      return <MobileAppCallToAction />;
  }
};

const mapStateToProps = (state) => ({
  propertyWalkThroughFormStep: selectPropertyWalkThroughFormStep(state),
});

export default connect(mapStateToProps)(PropertyWalkThroughFormSteps);
